import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type RenderVariantsState = Record<string, number>;

const initialState: RenderVariantsState = {};

export const renderVariantsSlice = createSlice({
    name: "renderVariants",
    initialState,
    reducers: {
        setRenderVariants: (_state, action: PayloadAction<RenderVariantsState>) => action.payload
    }
});

export const {setRenderVariants} = renderVariantsSlice.actions;

export const selectRenderVariant = (state: {renderVariants: RenderVariantsState}, id: string) => state.renderVariants[id] ?? 0;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export type RenderVariantsState = Record<string, number>;

const initialState: RenderVariantsState = {};

export const renderVariantsSlice = createSlice({
    name: "renderVariants",
    initialState,
    reducers: {
        setRenderVariants: (_state, action: PayloadAction<RenderVariantsState>) => action.payload
    }
});

export const {setRenderVariants} = renderVariantsSlice.actions;

export const selectRenderVariant = (state: {renderVariants: RenderVariantsState}, id: string) => state.renderVariants[id] ?? 0;
